module.exports = __webpack_public_path__ + "img/ASIAN.9b971c4a.jpg";